import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-arrow-line-right',
  templateUrl: './icon-arrow-line-right.component.html',
  styleUrls: ['./icon-arrow-line-right.component.scss'],
})
export class IconArrowLineRightComponent  implements OnInit {
 @Input() size :number = 20; 
  constructor() { }

  ngOnInit() {}

}
